import React from 'react';
interface SectionLabelProps {
  children?: React.ReactNode;
  tone?: 'cream' | 'blue';
}
export function SectionLabel({
  children,
  tone = 'blue'
}: SectionLabelProps) {
  const colorClass = tone === 'blue' ? 'bg-vm-electric' : 'bg-vm-cream';
  const textColorClass = tone === 'blue' ? 'text-vm-electric' : 'text-vm-cream';
  return <div className="flex items-center gap-3" data-id="element-176" data-mp="33efcx622y6r3">
      <span className={`h-px w-8 ${colorClass}`} aria-hidden="true" data-id="element-177" data-mp="3r3rk60duk4qr" />
      {children && <span className={`text-xs font-medium uppercase tracking-[0.25em] ${textColorClass}`} data-id="element-178" data-mp="3v53bqbga701l">
          {children}
        </span>}
    </div>;
}